import PropTypes from "prop-types";
import React from "react";
import XMLViewer from "react-xml-viewer";

const customTheme = {
  attributeKeyColor: "#B7B7B7",
  attributeValueColor: "#B7B7B7",
  textColor: "#8D8D8D",
  tagColor: "#FF585F",
  overflowBreak: true,
  separatorColor: "#3B86FF",
};

const XmlSection2 = (props) => {
  const { request, response, isLoading } = props;
  return (
    <div className="nip-home-interaction-inward">
      <div className="inward-xml-section">
        <div className="inward-xml-section-request">
          <div className="inward-xml-section-btn">REQUEST</div>
          {isLoading ? (
            "Loading..."
          ) : request === "" ? (
            <span>No Request Available</span>
          ) : (
            <XMLViewer xml={request} theme={customTheme} indentSize={3} />
          )}
        </div>
        <div className="inward-xml-section-response">
          <div className="inward-xml-section-btn response">RESPONSE</div>
          {isLoading ? (
            "Loading..."
          ) : response === "" ? (
            <span>No Response Available</span>
          ) : (
            <XMLViewer xml={response} theme={customTheme} indentSize={3} />
          )}
        </div>
      </div>
    </div>
  );
};

XmlSection2.propTypes = {
  isLoading: PropTypes.any,
  request: PropTypes.any,
  response: PropTypes.any,
};

export default XmlSection2;
